import {Injectable, OnDestroy} from '@angular/core';
import {FormDefinitionFieldModel} from '../../api/entity/formDefinitionField.model';
import {FormDefinitionFieldRepository} from './ngrx/formDefinitionField.repository';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {FormDefinitionFieldDataServiceAdapter} from './ngrx/formDefinitionFieldDataService.adapter';
import {Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {FormDefinitionFieldSummaryModel} from "../../api/entity/formDefinitionFieldSummary.model";
import {FormDefinitionFieldSummaryDataServiceAdapter} from "./ngrx/formDefinitionFieldSummaryDataService.adapter";

@Injectable({
    providedIn: "root"
})
export class FormDefinitionFieldSummaryFindAllService
    extends AbstractFindAllService<FormDefinitionFieldModel, FormDefinitionFieldSummaryModel>
    implements OnDestroy{

    constructor(repository: FormDefinitionFieldRepository, dataServiceAdapter: FormDefinitionFieldSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
